import { supabase } from '../lib/supabaseClient';

/**
 * Registra una acción en `audit_log` con el usuario actual como actor.
 * Nunca lanza: una falla de auditoría no debe romper la acción del usuario.
 */
export async function logAction(
  action: string,
  entity: string,
  entityId: string | null,
  detail: Record<string, unknown> = {},
): Promise<void> {
  const { data } = await supabase.auth.getUser();
  const { error } = await supabase.from('audit_log').insert({
    actor_id: data.user?.id ?? null,
    action,
    entity,
    entity_id: entityId,
    detail,
  });
  if (error) console.warn('No se pudo escribir en audit_log:', error.message);
}

// --- Auditoría paginada (Task 35) ---

export const AUDIT_PAGE_SIZE = 50;

export interface AuditRow {
  id: string;
  created_at: string;
  action: string;
  entity: string;
  entity_id: string | null;
  detail: unknown;
  actor: { dni: string; first_names: string; last_names: string } | null;
}

/** Página `page` (0-based) del audit_log, más reciente primero. Solo admin por RLS. */
export async function listAudit(page: number): Promise<{ rows: AuditRow[]; hasMore: boolean }> {
  const from = page * AUDIT_PAGE_SIZE;
  const { data, error } = await supabase
    .from('audit_log')
    .select('id, created_at, action, entity, entity_id, detail, actor:profiles(dni, first_names, last_names)')
    .order('created_at', { ascending: false })
    .range(from, from + AUDIT_PAGE_SIZE); // pide una fila extra para saber si hay más
  if (error) throw error;
  const rows = (data ?? []) as unknown as AuditRow[];
  return { rows: rows.slice(0, AUDIT_PAGE_SIZE), hasMore: rows.length > AUDIT_PAGE_SIZE };
}
